export default __webpack_public_path__ + "static/media/contact4.6038c70a.png";